<template>
  <apexchart type="donut" :options="chartOptions" :series="series"></apexchart>
</template>

<script>
import { cloneDeep } from "lodash";
import incidentMixin from '@/mixins/incident'
export default {
  mixins: [incidentMixin],
  data () {
    return {
      series: [],
      chartOptions: {
        labels: [],
        chart: {
          type: "donut",
        },
        dataLabels: {
          enabled: false,
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 300,
              },
            },
          },
        ],
      },
    };
  },

  computed: {
    incidentStatistics () {
      return this.$store.getters["socket/incident"].analysis;
    },
  },

  methods: {
    async generateChartData () {
      let violationData = cloneDeep(this.incidentStatistics.violationChartData);
      let filteredData = [];
      if (violationData) {
        violationData.forEach(function (a) {
          let index;
          if (
            filteredData.some(function (c, i) {
              index = i;
              return a.sub_category_name == c.sub_category_name;
            })
          ) {
            filteredData[index].count += a.count;
          } else {
            filteredData.push(a);
          }
        });
      }

      for (let i of filteredData) {
        if (this.chartOptions.labels.indexOf(i.sub_category_name) === -1) {
          this.series.push(i.count);
          this.chartOptions.labels.push(this.GetVidsFriendlyEventName(i.sub_category_name));
        }
      }
    },
  },

  mounted () {
    this.generateChartData();
  },
};
</script>
